export default {
  title: "Subscription",
  description: "Manage your subscription",
  currentPlan: "Current Plan",
  upgradePlan: "Upgrade Plan",
  downgradePlan: "Downgrade Plan",
  cancelSubscription: "Cancel Subscription",
  plan: {
    pro: "Pro",
    free: "Free",
    basic: "Basic",
    premium: "Premium",
    essential: "Essential"
  },
  plans: {
    free: "Free",
    basic: "Basic",
    premium: "Premium",
    pro: "Pro",
    essential: "Essential"
  },
  currentPlanMessage: {
    free: "You are on the Free plan",
    pro: "You are a Premium member!"
  },
  eventsUsed: "Events used",
  features: {
    unlimited: "Unlimited",
    limited: "Limited",
    guests: "Guests",
    events: "Events",
    tasks: "Tasks",
    vendors: "Vendors",
    budget: "Budget tracking",
    timeline: "Timeline",
    seating: "Seating plan",
    invitations: "Invitations",
    support: "Support",
    title: "Features",
    exportPDF: "PDF Export",
    exportExcel: "Excel Export",
    customDomain: "Custom Domain",
    adsRemoval: "No Ads",
    prioritySupport: "Priority Support",
    guestGroups: "Guest Groups",
    seatingPlanner: "Seating Planner",
    budgetAnalytics: "Budget Analytics",
    weddingWebsite: "Wedding Website",
    aiAssistant: "AI Assistant",
    customTemplates: "Custom Templates",
    mobileApp: "Mobile App",
    webhookIntegrations: "Webhook Integrations",
    multiLanguage: "Multi-language",
    customFields: "Custom Fields",
    storage: "Storage",
    analytics: "Analytics",
    customization: "Customization",
    collaboration: "Collaboration",
    export: "Export",
    domains: "Custom Domains"
  },
  billing: {
    monthly: "Monthly",
    yearly: "Yearly",
    save: "Save {{percentage}}%",
    nextBilling: "Next billing date",
    billingHistory: "Billing history",
    invoice: "Invoice",
    download: "Download",
    paymentMethod: "Payment method",
    updatePayment: "Update payment method",
    addPayment: "Add payment method"
  },
  pricing: {
    perMonth: "per month",
    perYear: "per year",
    billed: "Billed {{period}}",
    currency: "€"
  },
  actions: {
    subscribe: "Subscribe",
    upgrade: "Upgrade",
    downgrade: "Downgrade",
    cancel: "Cancel",
    confirm: "Confirm",
    continue: "Continue",
    back: "Back",
    reactivate: "Reactivate subscription"
  },
  messages: {
    subscriptionUpdated: "Subscription updated successfully",
    subscriptionCanceled: "Subscription canceled successfully",
    paymentMethodUpdated: "Payment method updated successfully",
    error: "An error occurred",
    upgradeSuccess: "Your plan has been upgraded successfully",
    downgradeSuccess: "Your plan has been downgraded successfully",
    cancelSuccess: "Your subscription has been canceled",
    reactivateSuccess: "Your subscription has been reactivated"
  },
  yourCurrentPlan: "Your current subscription",
  free: "Free",
  manage: "Manage my subscription",
  pageTitle: "Our Subscription Plans",
  pageDescription: "Choose the plan that best suits your needs",
  subscriptionUpdated: "Your subscription has been successfully updated",
  updateError: "An error occurred while updating your subscription",
  mostPopular: "Most popular",
  choosePlan: "Choose this plan",
  unlimited: "Unlimited",
  freePrice: "$0",
  essentialPrice: "${{price}}/month",
  proPrice: "${{price}}/month",
  freeDescription: "Perfect for getting started with your wedding planning",
  essentialDescription: "Ideal for weddings with up to 200 guests",
  proDescription: "For larger weddings with specific needs",
  viewPlans: "View plans",
  featureRestricted: "Restricted feature",
  upgradeToAccessFeature: "Upgrade to access {{feature}}",
  upgradeToAccessPlan: "Upgrade to {{plan}} plan to access this feature",
  upgradeToIncreaseLimits: "Upgrade to increase these limits",
  limitReached: "{{limit}} limit reached ({{count}}/{{max}})",
  multipleEventsRestricted: "Multiple events management restricted",
  upgradeToProForMultipleEvents: "Upgrade to Pro to manage multiple events",
  limits: {
    title: "Limits",
    events: "{{count}} events",
    guests: "{{count}} guests",
    collaborators: "{{count}} collaborators",
    storage: "{{size}} storage",
    maxGuests: "Guests",
    maxTasks: "Tasks",
    maxVendors: "Vendors",
    maxCollaborators: "Collaborators",
    maxBudgetItems: "Budget items",
    maxTimelineEvents: "Timeline events"
  },
  included: "Included",
  notIncluded: "Not included",
  monthly: "Monthly",
  yearly: "Yearly",
  perMonth: "per month",
  perYear: "per year",
  yearlyDiscount: "Save {{percent}}%",
  switchToMonthly: "Switch to monthly billing",
  switchToYearly: "Switch to yearly billing",
  renew: "Renew subscription",
  invoices: "Invoices",
  paymentHistory: "Payment History",
  paymentMethods: "Payment Methods",
  faq: {
    title: "Frequently Asked Questions",
    question1: "Can I change plans at any time?",
    answer1: "Yes, you can upgrade or downgrade your plan at any time. If you upgrade, you will be charged the pro-rated amount for the remainder of the month. If you downgrade, the change will take effect at the end of your current billing cycle.",
    question2: "What happens if I exceed my limits?",
    answer2: "If you reach the limits of your plan, you will be prompted to upgrade to a higher plan to continue adding items.",
    question3: "How does billing work?",
    answer3: "Billing is automatic and occurs monthly or yearly depending on your selection. You can cancel your subscription at any time from your account.",
    question4: "Can I get a refund?",
    answer4: "We offer a full refund within 14 days of your first paid subscription if you are not satisfied with our service.",
    multipleEventsQuestion: "Can I manage multiple events?",
    multipleEventsAnswer: "With the Pro plan, you can manage an unlimited number of events. Free and essential plans are limited to one event."
  },
  usingBasicFeatures: "Use of basic features"
,

  pageSubtitleNew: "Adapt WedBox to your needs with our flexible plans",
  refreshBtn: "Refresh",
  popular: "Popular",
  current: "Current",
  freePlanBtn: "Free plan",
  upgradeTo: "Upgrade to {{plan}}",
  currentPlanBtn: "Current plan",
  usage: {
    events: "Event Management",
    guests: "Guests",
    tasks: "Tasks",
    vendors: "Vendors"
  },
  units: {
    events: "event(s)",
    guests: "guest(s)",
    tasks: "task(s)",
    vendors: "vendor(s)"
  },
  checkout: {
    title: "Secure Payment",
    secureStripe: "Secure payment with Stripe",
    cancelAnytime: "You can cancel your subscription at any time from your account.",
    lastRefresh: "Last refresh:",
    mustBeLoggedIn: "You must be logged in to proceed to payment",
    freeNoPayment: "The free plan requires no payment",
    creatingSession: "Creating payment session...",
    redirecting: "Redirecting to Stripe...",
    subscribeTo: "Subscribe to {{plan}} plan",
    cancel: "Cancel",
    securePayment: "Secure payment via Stripe"
  },
  planDetails: {
    free: {
      name: "Free",
      price: "€0",
      description: "Perfect to get started",
      features: [
        "Manage 1 event",
        "Up to 50 guests",
        "Max 20 tasks",
        "10 vendors",
        "Community support"
      ]
    },
    essential: {
      name: "Essential",
      price: "€9",
      description: "For important events",
      features: [
        "Manage 3 events",
        "Up to 200 guests",
        "Unlimited tasks",
        "25 vendors",
        "PDF/Excel export",
        "Guest groups",
        "Priority support"
      ]
    },
    pro: {
      name: "Pro",
      price: "€19",
      description: "Complete solution",
      features: [
        "Unlimited events",
        "Unlimited guests",
        "Unlimited tasks",
        "Unlimited vendors",
        "Seating planner",
        "Advanced analytics",
        "Custom reports",
        "Premium support"
      ]
    }
  }

};
